import React from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import skeletons from './Skeletons';
import ErrorStateWithReload from '../../../../ErrorStateWithReload';
import InsightsCardBox from '../../../../../pages/app-insights/_shared/components/InsightsCardBox';
import PerformanceSnapshotTable from '../../../../../pages/app-insights/_shared/components/PerformanceSnapshotTable';
import ReleasedWithinLastYearNotification from '../../../../../pages/app-insights/app-overview/_shared/components/ReleasedWithinLastYearNotification';
import { sortSegmentsData } from '../../../../../pages/app-insights/_shared/config/finance/cohorts';

const emptyArray = [];
const emptyObject = {};

const decorateAdvancedInsights = (insights) => {
  if (isEmpty(insights) || insights.no_data) return emptyArray;

  const { groupedSegments } = sortSegmentsData(insights.all);

  return groupedSegments.all;
};

const FinancePerformanceSnapshot = ({
  widgets,
  settings,
  isAdvancedDataAbsent,
  releasedNotification,
}) => {
  const { metrics_insights = emptyArray, advanced_metrics_insights = emptyObject } = widgets;
  const { pending, error } = settings;

  const getData = () => {
    if (isAdvancedDataAbsent) return metrics_insights[0] || {};

    return decorateAdvancedInsights(advanced_metrics_insights)[0] || {};
  };

  if (error) return <ErrorStateWithReload />;

  return (
    <InsightsCardBox
      bodyMinHeight={118}
      className="finance-performance-snapshot card-box-sm"
      headerLeft={<h4 className="h4">Performance Snapshot</h4>}
    >
      {pending ? skeletons.performanceSnapshot : (
        <PerformanceSnapshotTable
          data={getData()}
          releasedNotification={releasedNotification}
        />
      )}
    </InsightsCardBox>
  );
};

FinancePerformanceSnapshot.propTypes = {
  widgets: T.object.isRequired,
  isAdvancedDataAbsent: T.bool,
  settings: T.object.isRequired,
  releasedNotification: T.node,
};

const FinanceInsightsWidgets = ({
  app,
  widgets,
  isAdvancedDataAbsent,
  settings,
}) => {
  const releasedNotification = widgets.released_within_last_year && (
    <ReleasedWithinLastYearNotification
      link={`/apps/${app.store}/${app.ref_no}/performance`}
    />
  );

  return (
    <FinancePerformanceSnapshot
      widgets={widgets}
      settings={settings}
      isAdvancedDataAbsent={isAdvancedDataAbsent}
      releasedNotification={releasedNotification}
    />
  );
};

FinanceInsightsWidgets.propTypes = {
  app: T.object.isRequired,
  widgets: T.object.isRequired,
  isAdvancedDataAbsent: T.bool,
  settings: T.object.isRequired,
};

export default FinanceInsightsWidgets;
